module.exports = "https://cdn-skillquest.mathletics.com/app/170/assets/fonts/cc3ef33c7f378f96eb76bef03bf4397a.woff2";